import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { loadersBuilder, errorBuilder, logoutBuilder } from '@modules/builders';

import accountsActions from './actions';
import initialState from './state';
import type * as AccountsTypes from './types';

export const accountsReducer = createReducer(initialState, builder => {
  builder.addCase(accountsActions.clearVerifyData, state => {
    delete state.verification;
  });

  builder.addCase(accountsActions.createAccount.fulfilled, (state, action) => {
    state.details.push(action.payload.data);
  });

  builder.addCase(accountsActions.accountBuy.fulfilled, (state, action) => {
    // todo
  });

  builder.addCase(accountsActions.accountSell.fulfilled, (state, action) => {
    // todo
  });

  builder.addCase(accountsActions.accountWithdraw.fulfilled, (state, action) => {
    state.verification = action.payload.data;
  });

  builder.addCase(accountsActions.accountWithdrawVerify.fulfilled, (state, action) => {
    // todo
  });

  builder.addCase(accountsActions.getAccountRecentTransactions.fulfilled, (state, action) => {
    // todo
  });

  builder.addCase(accountsActions.getAccountSellRate.fulfilled, (state, action) => {
    // todo
  });

  builder.addCase(accountsActions.getAccountBuyRate.fulfilled, (state, action) => {
    // todo
  });

  builder.addCase(accountsActions.setAccountCreated, (state, action) => {
    state.createAccountStatus = action.payload;
  });

  builder.addMatcher(
    isAnyOf(
      accountsActions.getAccountLimits.fulfilled,
      accountsActions.getAccountLimitsPolling.fulfilled
    ),
    (state, action) => {
      state.limits = action.payload.data;
    }
  );

  builder.addMatcher(
    isAnyOf(accountsActions.getAccounts.fulfilled, accountsActions.getAccountsPolling.fulfilled),
    (state, action) => {
      state.details = action.payload.data;
    }
  );
  errorBuilder('accounts', builder);
  logoutBuilder(initialState, builder);
  loadersBuilder('accounts', builder);
});

export { accountsActions, AccountsTypes };
